<label [attr.id]="(id || for) + '-label'" [attr.for]="id || for" class="field__label">{{label}}</label>
<input [ngModel]="text" [disabled]="disabled" (ngModelChange)="handleChange($event)" class="field__input" [id]="id"
       type="{{type}}" maxlength="{{maxlength}}" (blur)="handleBlur()" (focus)="handleFocus()"
       [ngClass]="{'field__input--error': errorMessages.length}" [attr.aria-describedby]="getDescribedBy()"/>
<div class="field__message" [ngClass]="{'hide': !helperText}">{{helperText}}</div>
<div *ngIf="errorMessages.length"
     [id]="(id||for)+'-error'"
     class="error-message"
     aria-live="assertive"
     aria-atomic="true" role="alert">
    <ErrorMessages [errorMessages]="errorMessages" [id]="getDescribedBy()"></ErrorMessages>
</div>
